/* Обёртка ничего не рисует — она держит рядом кнопку и живую область статуса. */
.wrap {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-3);
  min-width: 0;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  padding: var(--sp-1) var(--sp-3);
  font-size: var(--fs-xs);
  line-height: 1;
}

/* Кнопка-иконка карточки: тот же квадратик, что у правки и удаления
   в ui/timeline/TimelineCard.module.css — они стоят в одном ряду. */
.iconBtn {
  width: 24px;
  height: 24px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.label {
  white-space: nowrap;
}

.spinning {
  display: flex;
  animation: prices-spin 1.1s linear infinite;
}

@keyframes prices-spin {
  to {
    transform: rotate(360deg);
  }
}

/* Движение выключено — иконка просто замирает; о том, что идёт проверка,
   по-прежнему говорят role="status" и aria-busy. */
@media (prefers-reduced-motion: reduce) {
  .spinning {
    animation: none;
  }
}

.status {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-3);
  font-size: var(--fs-xs);
}

/* Сообщение у кнопки-иконки. Отдельным слоем, а не строкой в потоке: иконка
   стоит в ряду действий карточки и в шапке варианта, где всё обязано остаться
   одной строкой, — тот же приём, что у журнала снимков (sync/SnapshotControls).

   Нужен он ровно потому, что подсказка `title` на телефоне недостижима: пальцем
   не наводят. Без этого слоя ошибка проверки на узком экране не была бы видна
   нигде — а молчащий отказ читается как поломка.

   Прижато к экрану, а не к кнопке — и это единственное отличие от снимков.
   Кнопка снимков живёт в тулбаре, где места хватает всегда; кнопка цен стоит
   в карточке библиотеки, панель которой тянется мышью до 200px. Всплывашка
   шириной в свой текст уезжала оттуда левым краем в −45px и обрезалась краем
   экрана. Привязка к экрану не обрезается никогда и не зависит от того, где
   оказалась кнопка. */
.toast {
  position: fixed;
  right: var(--sp-4);
  bottom: var(--sp-4);
  z-index: 1100;
  /* Ширина по содержимому: на широком мониторе полоса во всю ширину под
     короткое «Слишком часто» — это баннер, а не сообщение у кнопки. */
  width: max-content;
  max-width: min(320px, calc(100vw - var(--sp-4) * 2));
  padding: var(--sp-2) var(--sp-4);
  background: var(--surface);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-card);
  color: var(--text-2);
  font-size: var(--fs-xs);
}

/* ── Мобильный вид (порог продублирован в ui/shell/useIsMobile.ts) ──────── */
@media (max-width: 720px) {
  /* Пальцу нужна цель побольше — размер тот же, что у соседних кнопок
     карточки на телефоне. */
  .iconBtn {
    width: 38px;
    height: 32px;
  }

  /* На телефоне сообщение разворачивается на всю ширину — как у снимков:
     узкий экран, читать удобнее одной колонкой по центру. */
  .toast {
    left: var(--sp-4);
    width: auto;
    max-width: none;
    text-align: center;
  }
}
